import { Children, useMemo } from 'react';
export default function useSlots(component, children) {
    return useMemo(() => Children.toArray(children).reduce((res, el) => {
        var _a, _b;
        const [target, slot] = ((_b = (_a = el === null || el === void 0 ? void 0 : el.type) === null || _a === void 0 ? void 0 : _a.slot) === null || _b === void 0 ? void 0 : _b.split(':')) || [];
        if (!target || target !== component) {
            res['children'] = [...(res['children'] || []), el];
        }
        if (target === component && slot) {
            res[slot] = [...(res[slot] || []), el];
        }
        return res;
    }, {}), [children, component]);
}
//# sourceMappingURL=use-slots.js.map